<template>
    <div></div>
</template>

<script>
export default {
    name: 'DeleteCatalogProduct',
    props: {
        popupDeleteCatalog: {
            type: Boolean,
            default: false,
        },
        catalogId: Number
    },

    watch: { 
      	popupDeleteCatalog: function(newVal) {
            if(newVal == true){
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: "حذف کاتالوگ",
                    text: `کاتالوگ حذف شود؟`,
                    acceptText: "حذف",
                    cancelText: "انصراف",
                    accept: this.deleteCatalog,
                    cancel: this.cancelDelete,
                })
            }            
        },
    },
    
    methods: {
        cancelDelete(){
            this.$emit('updatePopupDeleteCatalog', false)
        },

        deleteCatalog(){
            this.$vs.loading()
            this.$emit('updatePopupDeleteCatalog', false)
            let id = this.catalogId
            let type = 'catalog'
			this.$store.dispatch('deletePost', { id, type })
			.then(() => {
				this.$vs.loading.close()
				this.$vs.notify({
					title: '',
					text: 'مقاله با موفقیت حذف شد.',
					iconPack: 'feather',
					icon: 'icon-check-square',
					color: 'success'
				})
			})
			.catch(() => {
				this.$vs.loading.close()
				this.$vs.notify({
				title: '',
				text: 'خطا در اتصال به اینترنت',
				iconPack: 'feather',
				icon: 'icon-alert-circle',
				color: 'warning'
				})
			})
		},
    }
}
</script>